'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'couch';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'f4b8';
var svgPathData = 'M112 192l0 44.1c17.2 11.5 29.2 30.3 31.6 51.9l352.9 0c2.4-21.6 14.4-40.4 31.6-51.9l0-44.1c0-44.2-35.8-80-80-80l-256 0c-44.2 0-80 35.8-80 80zM64 224.4L64 192c0-70.7 57.3-128 128-128l256 0c70.7 0 128 57.3 128 128l0 32.4c36 4 64 34.5 64 71.6l0 64c0 48.6-39.4 88-88 88L88 448c-48.6 0-88-39.4-88-88l0-64c0-37.1 28-67.6 64-71.6zM48 296l0 64c0 22.1 17.9 40 40 40l464 0c22.1 0 40-17.9 40-40l0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 16c0 13.3-10.7 24-24 24l-400 0c-13.3 0-24-10.7-24-24l0-16c0-13.3-10.7-24-24-24s-24 10.7-24 24z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCouch = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;